import { Pipe, PipeTransform } from '@angular/core';
import {DataAttribute} from '@app/views/admin/application-settings/models/data-attribute.model';
import {FilterRuleMetadata} from '@app/core/model/filtering/filter-rule-metadata';

@Pipe({
    name: 'ngcGetAttributesListForPreCreatedFilters'
})
export class GetAttributesListForPreCreatedFiltersPipe implements PipeTransform {

    transform(preCreatedPropertyList: string[][], filterRulesMetadata: FilterRuleMetadata[], selectedEntity: string): DataAttribute[][] {
        const taskMetadata = filterRulesMetadata.find((item: FilterRuleMetadata) => item.type === selectedEntity);
        const attributesListBySelectedEntityName = (taskMetadata && taskMetadata.taskIdList.length > 0) ? taskMetadata.attributes : [];

        const attributesList = <DataAttribute[][]>[];
        preCreatedPropertyList.forEach((propertyList: string[]) => {

            const preCreatedAttributesList = attributesListBySelectedEntityName.filter((attr: DataAttribute) =>
                propertyList.indexOf(attr.propertyName) > -1);
            if (preCreatedAttributesList.length > 0) {
                preCreatedAttributesList.sort((attrA: DataAttribute, attrB: DataAttribute) => {
                    if (propertyList.indexOf(attrA.propertyName) < propertyList.indexOf(attrB.propertyName)) {
                        return -1;
                    }
                    if (propertyList.indexOf(attrA.propertyName) > propertyList.indexOf(attrB.propertyName)) {
                        return 1;
                    }
                    return 0;
                });
                attributesList.push(preCreatedAttributesList);
            }

        });

        return attributesList;
    }

}
